import { render, staticRenderFns } from "./HeartysanCategoryTable.vue?vue&type=template&id=73ff59e2&scoped=true"
import script from "./HeartysanCategoryTable.vue?vue&type=script&lang=js"
export * from "./HeartysanCategoryTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73ff59e2",
  null
  
)

export default component.exports